import { styled } from '@f8n-frontend/stitches';
import React, { ReactElement } from 'react';

import Text from 'components/base/Text';

const StoryParagraphBase = styled(Text, {
  lineHeight: '$3',
  display: 'inline',
  '& b': {
    fontWeight: '$semibold',
  },
  '& i': {
    fontStyle: 'italic',
  },
  // TODO(storytelling): Style underline w/ borderBottom
  '& u': {
    textDecoration: 'underline',
  },
  '& p:not(:last-child)': {
    marginBottom: '1.5rem',
  },
});

function StoryParagraph(props: { children: React.ReactNode; as: 'div' | 'p' }) {
  return (
    <StoryParagraphBase as={props.as} size={{ '@initial': 2, '@bp0': 3 }}>
      {props.children}
    </StoryParagraphBase>
  );
}

const StoryH1Base = styled(Text);

function StoryH1(props: { children: string | ReactElement }) {
  return (
    <StoryH1Base as="h1" size={{ '@initial': 5, '@bp0': 6 }} lineHeight={1}>
      {props.children}
    </StoryH1Base>
  );
}

const StoryH2Base = styled(Text);

function StoryH2(props: { children: string | ReactElement }) {
  return (
    <StoryH2Base as="h2" size={{ '@initial': 4, '@bp0': 5 }} lineHeight={1}>
      {props.children}
    </StoryH2Base>
  );
}

const StoryBlockquoteBase = styled(Text, {
  display: 'flex',
  flexDirection: 'column',
  gap: '$4',
  textAlign: 'center',
  '& textarea': {
    textAlign: 'center',
  },
  '& cite': {
    display: 'block',
    fontStyle: 'normal',
    color: '$black60',
    lineHeight: '$3',
    fontSize: '$1',
    letterSpacing: '$0',
  },
});

function StoryBlockquote(props: { children: React.ReactNode }) {
  return (
    <StoryBlockquoteBase
      as="blockquote"
      size={{ '@initial': 5, '@bp0': 6 }}
      lineHeight={1}
    >
      {props.children}
    </StoryBlockquoteBase>
  );
}

export const Story = {
  Blockquote: StoryBlockquote,
  H1: StoryH1,
  H2: StoryH2,
  Paragraph: StoryParagraph,
};
